export const COMPRESSION_OPTION_NONE = { value: 'NONE', title: 'None' };
export const COMPRESSION_OPTION_ZIP = { value: 'ZIP', title: 'ZIP File' };
export const COMPRESSION_OPTION_ZST = { value: 'ZST', title: 'ZST File' };
export const COMPRESSION_OPTIONS_ARR = [COMPRESSION_OPTION_NONE, COMPRESSION_OPTION_ZIP, COMPRESSION_OPTION_ZST];
